module.exports = __webpack_public_path__ + "static/media/Stress-vs.-Overall-(Observed).99310229.png";